import * as Rx from 'rxjs'
import {IIdentityProvider} from '../PA.Core.IF.Basic'
import * as _ from 'lodash'
import {Record} from 'js-data'

export interface IdentityProviderOptions {
    id?: string | number,
    id_ui?: string | number,
    name?: string,
    createdBy?: string | number,
    mdset?: string | number,
    company?: string | number,
    salesOrg?: string | number,
    salesArea?: string | number,
    dataMart?: string | number,
}

export class IdentityProvider implements IIdentityProvider {

    _id: number | string
    _id_ui: number | string
    _name: string
    _createdBy: number | string
    _mdset: number | string
    _company: number | string
    _salesOrg: number | string
    _salesArea: number | string
    _dataMart: number | string

    //--Writeback Functionality
    _wbRecord: Record | any

    _bIdUIWriteBackEnabled: boolean
    _id_ui_fieldName: string

    _bNameWriteBackEnabled: boolean
    _name_fieldName: string

    _listeners: IIdentityProvider[]

    constructor(opts?: IdentityProviderOptions) {
        this._id = ''
        this._id_ui = ''
        this._name = ''
        this._createdBy = ''
        this._company = ''
        this._salesOrg = ''
        this._salesArea = ''
        this._mdset = ''
        this._dataMart = ''
        this._IdentityChanged = new Rx.BehaviorSubject<IIdentityProvider>(this);
        this._listeners = []
        this._bIdUIWriteBackEnabled = false
        this._bNameWriteBackEnabled = false

        if (opts) {
            if ('id' in opts) {
                this._id = opts.id;
                this._id_ui = opts.id;
            }

            if ('id_ui' in opts) {
                this._id_ui = opts.id_ui;
            }

            if ('name' in opts) {
                this._name = opts.name;
            }

            if ('createBy' in opts) {
                this._createdBy = opts.createdBy;
            }

            if ('mdset' in opts) {
                this._mdset = opts.mdset;
            }

            if ('company' in opts) {
                this._company = opts.company;
            }

            if ('salesOrg' in opts) {
                this._salesOrg = opts.salesOrg;
            }

            if ('salesArea' in opts) {
                this._salesArea = opts.salesArea;
            }

            if ('dataMart' in opts) {
                this._dataMart = opts.dataMart;
            }
        }
    }

    get id(): number | string {
        return this._id;
    }

    get id_ui(): number | string {
        return this._id_ui;
    }

    get name(): string {
        return this._name;
    }

    get createdBy(): number | string {
        return this._createdBy;
    }

    set id_ui(value: number | string) {
        this.setIdUI(value)
    }

    set name(value: string) {
        this.setName(value)
    }

    set createdBy(value: number | string) {
        this._createdBy = value
    }

    get mdset(): any {
        return this._mdset
    }

    set mdset(value: number | string) {
        this._mdset = value
        this._notify();
    }

    setMDSet(value: number | string) {
        this._mdset = value
        this._notify();
    }

    get company(): any {
        return this._company
    }

    set company(value: number | string) {
        this.company = value
    }

    get salesOrg(): any {
        return this._salesOrg

    }

    set salesOrg(value: number | string) {
        this._salesOrg = value
        this._notify();
    }

    setSalesOrg(value: number | string) {
        this._salesOrg = value
        this._notify();
    }


    get salesArea(): any {
        return this._salesArea
    }

    set salesArea(value: number | string) {
        this._salesArea = value
    }

    get dataMart(): any {
        return this._dataMart
    }

    set dataMart(value: number | string) {
        this._dataMart = value
        this._notify();
    }

    setDataMart(value: number | string) {
        this._dataMart = value
        this._notify();
    }

    _IdentityChanged: Rx.BehaviorSubject<IIdentityProvider>;

    get IdentityChanged(): Rx.BehaviorSubject<IIdentityProvider> {
        return this._IdentityChanged;
    }

    setAll(id?: number | string, id_ui?: number | string, name?: string, createdBy?: number | string): void {
        if (id)
            this._id = id;

        if (id_ui)
            this._id_ui = id_ui;

        if (name)
            this._name = name;

        if (createdBy)
            this._createdBy = createdBy

        this._notify();

        _.forEach(this._listeners, (anIdP: IIdentityProvider) => {
            anIdP.setAll(id, id_ui, name, createdBy)
        })
    }

    setId(id: number | string): void {
        this._id = id;
        this._notify();

        _.forEach(this._listeners, (anIdP: IIdentityProvider) => {
            anIdP.setId(id)
        })
    }

    setIdUI(id_ui: number | string): void {
        this._id_ui = id_ui;

        if (this._bIdUIWriteBackEnabled && (id_ui != this._wbRecord[this._id_ui_fieldName])) {
            this._wbRecord[this._id_ui_fieldName] = id_ui
        }

        this._notify();

        _.forEach(this._listeners, (anIdP: IIdentityProvider) => {
            anIdP.setIdUI(id_ui)
        })
    }

    setName(name: string): void {
        this._name = name;

        if (this._bNameWriteBackEnabled && (name != this._wbRecord[this._name_fieldName])) {
            this._wbRecord[this._name_fieldName] = name
        }

        this._notify();

        _.forEach(this._listeners, (anIdP: IIdentityProvider) => {
            anIdP.setName(name)
        })
    }

    _notify() {
        var self = this;
        setTimeout(function () {
            self.IdentityChanged.next(self);
        }, 0)
    }


    addListener(anIdentityProvider: IIdentityProvider): void {
        if (_.isEmpty(anIdentityProvider))
            return;

        this._listeners.push(anIdentityProvider)
    }

    removeListener(anIdentityProvider: IIdentityProvider): void {
        if (_.isEmpty(anIdentityProvider)) {
            return;
        }

        _.remove(this._listeners, (item: IIdentityProvider) => {
            return anIdentityProvider === item
        })

    }


    removeAllListeners(): void {
        this._listeners = []
    }

    listenToRecordUpdates(aRecord: Record,
                          id_fieldName: string,
                          id_ui_fieldName: string,
                          name_fieldName: string) {
        const self = this

        if (_.isEmpty(aRecord)) {
            return
        }

        if (!_.isEmpty(id_fieldName))
            aRecord.on('change:' + id_fieldName, (record: any, value: any) => {
                self.setId(record[id_fieldName])
            });


        if (!_.isEmpty(id_ui_fieldName))
            aRecord.on('change:' + id_ui_fieldName, (record: any, value: any) => {
                self.setIdUI(record[id_ui_fieldName])
            });

        if (!_.isEmpty(name_fieldName))
            aRecord.on('change:' + name_fieldName, (record: any, value: any) => {
                self.setName(record[name_fieldName])
            });

    }

    enableRecordWriteBack(aRecord: Record,
                          id_ui_fieldName?: string,
                          name_fieldName?: string) {
        const self = this

        if (_.isEmpty(aRecord))
            return

        this._wbRecord = aRecord
        if (!_.isEmpty(id_ui_fieldName)) {
            this._bIdUIWriteBackEnabled = true
            this._id_ui_fieldName = id_ui_fieldName
        }
        if (!_.isEmpty(name_fieldName)) {
            this._bNameWriteBackEnabled = true
            this._name_fieldName = name_fieldName
        }

    }

    get bHasIdUIWriteBack(): boolean {
        return this._bIdUIWriteBackEnabled
    }

    get bHasNameWriteBack(): boolean {
        return this._bNameWriteBackEnabled
    }

}
